import { $menuOpen, $lastFocusedElement, toggleMenu as storeToggleMenu } from '../_store.js';
import * as focusTrap from 'focus-trap';
class SearchPage extends HTMLElement {
  constructor() {
    super();
    this.filterTriggers = this.querySelectorAll('[data-action="filter"]');
    this.clearButton = this.querySelector('[data-action="clear"]');
    this.searchForm = document.getElementById('search-form');
  }
  connectedCallback() {
    console.log('SearchPage connected');

    // bindings
    this.bndHandleFilterClick = this.handleFilterClick.bind(this);
    this.bndHandleClearClick = this.handleClearClick.bind(this);

    // Add click event listeners to filter buttons
    this.filterTriggers.forEach(trigger => {
      trigger.addEventListener('click', this.bndHandleFilterClick);
    });

    // Add click event listener to clear button
    if (this.clearButton) {
      this.clearButton.addEventListener('click', this.bndHandleClearClick);
    }
  }
  disconnectedCallback() {
    // Remove event listeners when component is disconnected
    this.filterTriggers.forEach(trigger => {
      trigger.removeEventListener('click', this.bndHandleFilterClick);
    });
    if (this.clearButton) {
      this.clearButton.removeEventListener('click', this.bndHandleClearClick);
    }
  }
  handleFilterClick(event) {
    event.preventDefault();

    // Get the post type from the data-type attribute
    const postType = event.currentTarget.dataset.type;
    if (this.searchForm && postType) {
      // Check if a post_type input already exists
      let postTypeInput = this.searchForm.querySelector('input[name="post_type"]');

      // Create the input if it doesn't exist, otherwise update its value
      if (!postTypeInput) {
        postTypeInput = document.createElement('input');
        postTypeInput.type = 'hidden';
        postTypeInput.name = 'post_type';
        this.searchForm.appendChild(postTypeInput);
      }

      // Set the post type value
      postTypeInput.value = postType;

      // Submit the form
      this.searchForm.submit();
    }
  }
  handleClearClick(event) {
    // Prevent default form reset behavior
    event.preventDefault();
    if (this.searchForm) {
      // Clear the search input
      const searchInput = this.searchForm.querySelector('input[name="s"]');
      if (searchInput) {
        searchInput.value = '';
        // Focus the search field for better UX
        searchInput.focus();
      }

      // Remove the post_type hidden input if it exists
      const postTypeInput = this.searchForm.querySelector('input[name="post_type"]');
      if (postTypeInput) {
        postTypeInput.remove();
      }

      // We're not submitting the form anymore, just clearing the field
    }
  }
}
customElements.define('search-page', SearchPage);